/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type { GoogleMapsBrowserConfig } from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useGoogleMapsGetBrowserConfigHook = () => {
  const googleMapsGetBrowserConfig =
    useCustomInstance<GoogleMapsBrowserConfig>();

  return useCallback(
    (signal?: AbortSignal) => {
      return googleMapsGetBrowserConfig({
        url: `/api/GoogleMaps/GetBrowserConfig`,
        method: 'GET',
        signal,
      });
    },
    [googleMapsGetBrowserConfig]
  );
};

export const getGoogleMapsGetBrowserConfigQueryKey = () => {
  return [`/api/GoogleMaps/GetBrowserConfig`] as const;
};

export const useGoogleMapsGetBrowserConfigQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGoogleMapsGetBrowserConfigHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGoogleMapsGetBrowserConfigHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGoogleMapsGetBrowserConfigQueryKey();

  const googleMapsGetBrowserConfig = useGoogleMapsGetBrowserConfigHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGoogleMapsGetBrowserConfigHook>>>
  > = ({ signal }) => googleMapsGetBrowserConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGoogleMapsGetBrowserConfigHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GoogleMapsGetBrowserConfigQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGoogleMapsGetBrowserConfigHook>>>
>;
export type GoogleMapsGetBrowserConfigQueryError = unknown;

export const useGoogleMapsGetBrowserConfig = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGoogleMapsGetBrowserConfigHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGoogleMapsGetBrowserConfigHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGoogleMapsGetBrowserConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
